import filter from '~/utils/filter/install'
import constantHelper from '~/utils/constants/install'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(constantHelper)
  nuxtApp.vueApp.use(filter)
})
